const Dashboard = () => {
  return 'Welcome!';
};

export default Dashboard;
